import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL, COMM_URL } from '@/constants';
import _ from 'lodash';

export default {
	async getPartCkuMstList({ partNo, currentPage, pageUnit }) {
		const params = { partNo, pageUnit, currentPage };
		const queryString =
			'?' +
			Object.entries(params)
				.map(([key, val]) => (!_.isNil(val) ? `${key}=${val}` : ''))
				.filter(r => r)
				.join('&');

		//return client.get(`${BASE_URL}/pqy/pcku/partCkuPrvs/v1/partNo/${partNo}/mstLists` + queryString).then(res => res.data);

		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/partCkuPrvs/v1/partNo/${partNo}/mstLists` + queryString);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getCommCodes(codeType) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/undefined/commonCodes?commCdType=${codeType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	// custom 코드조회
	async getCommCodeDetails(codeType) {
		try {
			const params = { commCdType: codeType, sqlId: 'custDescSql_3', commCd: '', refCd: '' };
			const queryString =
				'?' +
				Object.entries(params)
					.map(([key, val]) => (!_.isNil(val) ? `${key}=${val}` : ''))
					.filter(r => r)
					.join('&');

			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/custCodeLists` + queryString);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async saveMaster({ partNo, saveRows }) {
		try {
			const response = await client.post(`${BASE_URL}/pqy/pcku/partCkuPrvs/v1/status/1/partNo/${partNo}`, saveRows);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async deleteMaster({ partNo, delRows }) {
		try {
			const response = await client.post(`${BASE_URL}/pqy/pcku/partCkuPrvs/v1/status/3/partNo/${partNo}`, delRows);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getPartCkuDtlList: ({ partNo, ckuPrvsCd, prvsClCd, currentPage, pageUnit }) => {
		const params = { currentPage, pageUnit };
		const queryString =
			'?' +
			Object.entries(params)
				.map(([key, val]) => (!_.isNil(val) ? `${key}=${val}` : ''))
				.filter(r => r)
				.join('&');

		return client
			.get(`${BASE_URL}/pqy/pcku/partCkuPrvs/v1/partNo/${partNo}/ckuPrvsCd/${ckuPrvsCd}/prvsClCd/${prvsClCd}/dtlLists` + queryString)
			.then(res => res.data);
	},
	// ,
	// async getPartCkuMstList({ searchParams, currentPage, pageUnit }) {
	// 	let queryStr = '';
	// 	if (searchParams.partNo !== undefined || searchParams.partNm !== undefined || searchParams.useYn !== undefined) {
	// 		queryStr = objectToQueryString({
	// 			partNo: searchParams.partNo,
	// 			partNm: searchParams.partNm,
	// 			// useYn: searchParams.useYn,
	// 			currentPage,
	// 			pageUnit
	// 		});
	// 	}
	// 	try {
	// 		const response = await client.get(`${BASE_URL}/comm/qmsbase/partMng/v1/parts${queryStr}`);
	// 		return response?.data || null;
	// 	} catch (error) {
	// 		throw error.response?.data;
	// 	}
	// }
	async saveDetail({ mstParams, saveRows }) {
		const partNo = mstParams.partNo;
		const ckuPrvsCd = mstParams.ckuPrvsCd;
		const prvsClCd = mstParams.prvsClCd;
		try {
			const response = await client.post(
				`${BASE_URL}/pqy/pcku/partCkuPrvs/v1/status/1/partNo/${partNo}/ckuPrvsCd/${ckuPrvsCd}/prvsClCd/${prvsClCd}/`,
				saveRows
			);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	//상세항목 삭제
	async deleteDetail({ mstParams, delRows }) {
		const partNo = mstParams.partNo;
		const ckuPrvsCd = mstParams.ckuPrvsCd;
		const prvsClCd = mstParams.prvsClCd;
		try {
			const response = await client.post(
				`${BASE_URL}/pqy/pcku/partCkuPrvs/v1/status/3/partNo/${partNo}/ckuPrvsCd/${ckuPrvsCd}/prvsClCd/${prvsClCd}/`,
				delRows
			);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/* 팝업관련 로직시작 */
	getPopupMasterList: ({ searchParams, currentPage, pageUnit }) => {
		const queryStr = objectToQuerystring({
			partNo: searchParams.partNo,
			currentPage,
			pageUnit
		});
		return client
			.get(`${BASE_URL}/pqy/pcku/partCkuPrvs/v1/copys` + queryStr)
			.then(response => response?.data)
			.catch(error => {
				throw error?.response?.data;
			});
	},
	getPopupList: ({ partNo }) => {
		//console.log('params >>>>> ', partNo);
		return client.get(`${BASE_URL}/pqy/pcku/partCkuPrvs/v1/partNo/${partNo}/copys`).then(res => res.data);
	},
	async savePopupList({ partNo, saveRows }) {
		try {
			const response = await client.post(`${BASE_URL}/pqy/pcku/partCkuPrvs/v1/status/1/cpPartNo/${partNo}/copyList`, saveRows);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	// 엑셀템플릿 다운로드
	async excelTempDown(params) {
		try {
			const response = await client.post(`${BASE_URL}/comm/common/qmsFileInfo/v1/downExcelTemp`, params, {
				responseType: 'blob'
			});
			return response;
		} catch (error) {
			throw new Error(error.response?.data);
		}
	},
	//상세항목
	async saveCpkDef_({ mstParams, params }) {
		const partNo = mstParams.partNo;
		const ckuPrvsCd = mstParams.ckuPrvsCd;
		const prvsClCd = mstParams.prvsClCd;
		const queryStr = objectToQuerystring({
			defCpk: params.defCpk
		});
		try {
			const response = await client.post(
				`${BASE_URL}/pqy/pcku/partCkuPrvs/v1/status/1/partNo/${partNo}/ckuPrvsCd/${ckuPrvsCd}/prvsClCd/${prvsClCd}/defCpk` + queryStr,
				params
			);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
